import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { BusinessPourAvailability } from '@barboxx/models';

interface Props {
    pourAvailability: BusinessPourAvailability.DetailsResponse;
}

export const PourAvailabilityDeleteCard = ({ pourAvailability }: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeletePourAvailability = useMutation({
        mutationKey: ['deletePourAvailability', pourAvailability.id],
        mutationFn: () =>
            Api.BusinessSpecific.PourAvailability.deletePourAvailability(
                pourAvailability
            ),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this pour availability!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete Pour availability',
            }
        );

        if (!deleteConfirmed) {
            return;
        }
        mutateDeletePourAvailability
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted pour availability!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notifications.show('Error Deleting pour availability!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete PourAvailability" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this pour availability?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
